import { ObjectFitEnum } from '@vedalib/editor/lib/files'

export const getObjectFitDivMap = (sideValues?: ObjectFitEnum) =>
  sideValues &&
  {
    [ObjectFitEnum.fill]: '100% 100%' as const,
    [ObjectFitEnum.contain]: 'contain' as const,
    [ObjectFitEnum.cover]: 'cover' as const,
  }[sideValues]
